import { Box } from "@chakra-ui/react";
import type { ReactNode } from "react";

type GroupThProps = {
  colSpan?: number;
  borderLeft?: boolean;
  bg?: string;
  color?: string;
  children?: ReactNode;
};

export function PopupImportGroupTh({
  colSpan,
  borderLeft = false,
  bg,
  color,
  children,
}: GroupThProps) {
  return (
    <Box
      as="th"
      colSpan={colSpan}
      p="6px 8px"
      fontSize="11px"
      fontWeight="bold"
      color={color ?? "#4A5568"}
      bg={bg ?? "#FAFAFA"}
      borderBottom="1px solid #CBD5E0"
      borderLeft={borderLeft ? "2px solid #CBD5E0" : undefined}
      textAlign="center"
      whiteSpace="normal"
      wordBreak="break-word"
      lineHeight="1.2"
    >
      {children}
    </Box>
  );
}

type ColThProps = {
  borderLeft?: boolean;
  sticky?: boolean;
  stickyLeft?: string;
  bg?: string;
  color?: string;
  children?: ReactNode;
};

export function PopupImportColTh({
  borderLeft = false,
  sticky = false,
  stickyLeft,
  bg,
  color,
  children,
}: ColThProps) {
  return (
    <Box
      as="th"
      p="6px 8px"
      fontSize="11px"
      fontWeight="bold"
      color={color ?? "#4A5568"}
      bg={bg ?? "#FAFAFA"}
      borderBottom="2px solid #CBD5E0"
      borderLeft={borderLeft ? "2px solid #CBD5E0" : undefined}
      whiteSpace="normal"
      wordBreak="break-word"
      lineHeight="1.2"
      textAlign="center"
      position={sticky ? "sticky" : undefined}
      left={sticky ? stickyLeft ?? 0 : undefined}
      zIndex={sticky ? 3 : undefined}
      maxW={sticky ? undefined : "160px"}
      title={typeof children === "string" ? children : undefined}
    >
      {children}
    </Box>
  );
}
